import Client from '@/client'

export default {
  get_filters(id, payload) {
    return Client.post(`forecasting/${id}/get_filters/`, payload)
  },
  get_map_data(id, payload) {
    return Client.post(`forecasting/${id}/get_map_data/`, payload)
  },
  get_frame_data(id, payload) {
    return Client.post(`forecasting/${id}/get_frame_data/`, payload)
  },
  get_filtered_wells(id, payload) {
    return Client.post(`forecasting/${id}/get_filtered_wells/`, payload)
  },
  get_production(id, payload) {
    return Client.post(`forecasting/${id}/get_production/`, payload)
  },
  get_type_curves(id, payload) {
    return Client.post(`forecasting/${id}/get_type_curves/`, payload)
  },
  get_statistics(id, payload) {
    return Client.post(`forecasting/${id}/get_statistics/`, payload)
  },
  get_ratios(id, payload) {
    return Client.post(`forecasting/${id}/get_ratios/`, payload)
  },
  get_probit(id, payload) {
    return Client.post(`forecasting/${id}/get_probit/`, payload)
  },
  get_decline(id, payload) {
    return Client.post(`forecasting/${id}/get_decline/`, payload)
  },
  get_terminal_declines(id, payload) {
    return Client.post(`forecasting/${id}/get_terminal_declines/`, payload)
  },
  get_downloads(id, payload) {
    return Client.post(`forecasting/${id}/get_downloads/`, payload)
  },
  get_well_data(id, payload) {
    return Client.post(`forecasting/${id}/get_well_data/`, payload)
  },
  get_economics(id, payload) {
    return Client.post(`forecasting/${id}/get_economics/`, payload)
  },
  get_multistats(id, payload) {
    return Client.post(`forecasting/${id}/get_multistats/`, payload)
  },
  get_summary(id, payload) {
    return Client.post(`forecasting/${id}/get_summary/`, payload)
  },
  get_calculations(id, payload) {
    return Client.post(`forecasting/${id}/get_calculations/`, payload)
  },
}